"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ARTWORK_COLORS = exports.PHOTO_ORIENTATIONS = void 0;
exports.PHOTO_ORIENTATIONS = {
    SQUARE: 'square',
    PORTRAIT: 'portrait',
    LANDSCAPE: 'landscape'
};
exports.ARTWORK_COLORS = [
    'black', 'blue', 'brown', 'gray', 'green', 'orange', 'pink', 'purple', 'red', 'turquoise', 'white', 'yellow'
];
//# sourceMappingURL=artConsts.js.map